import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const COLUMNS: ReportColumn[] = [
  { key: 'title', label: 'Booking' },
  { key: 'facility', label: 'Facility' },
  { key: 'booked_by', label: 'Booked By' },
  { key: 'start_at', label: 'Start' },
  { key: 'end_at', label: 'End' },
  { key: 'status', label: 'Status' },
];

export function BookingsRegisterReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Bookings Register"
      description="Every facility booking, with time range and status."
      endpoint="/reports/resources/bookings-register"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={listOptions(lists, 'booking_status')}
      listColumns={{ status: 'booking_status' }}
    />
  );
}
